import {
  documentTemplates,
  documentTypesLocales as libDocumentTypesLocales,
} from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import locales from '../pages/DocumentUpload/locales';
import getLibraryBasedLocales from './getLibraryBasedLocales';
import { DocumentTypeProperties, UploadableDocumentType } from './types';
import uploadableDocumentTypesList from './uploadableDocumentTypesList';

const documentTypesLocales = new LocalizedStrings(libDocumentTypesLocales);

type DocumentTypePropertiesRecord = Record<
  UploadableDocumentType,
  DocumentTypeProperties
>;

interface MapResult extends DocumentTypeProperties {
  documentType: UploadableDocumentType;
}

const documentTypeProperties: DocumentTypePropertiesRecord =
  uploadableDocumentTypesList
    .map((documentType): MapResult | null => {
      const documentTemplate = documentTemplates[documentType];
      let downloadFormUrl;
      if (documentTemplate === null) {
        downloadFormUrl = undefined;
      } else if ('url' in documentTemplate) {
        downloadFormUrl = documentTemplate.url;
      } else if ('getUrl' in documentTemplate) {
        downloadFormUrl = documentTemplate.getUrl;
      }
      return {
        documentType,
        downloadFormUrl,
        locales: {
          uploadedDocumentName: documentTypesLocales[documentType].label,
          ...getLibraryBasedLocales(documentType),
          ...locales[documentType],
        },
      };
    })
    .reduce<DocumentTypePropertiesRecord>((acc, mapResult) => {
      if (mapResult !== null) {
        const { documentType, ...documentProperties } = mapResult;
        return { ...acc, [documentType]: documentProperties };
      }
      return acc;
    }, {} as DocumentTypePropertiesRecord);

export default documentTypeProperties;
